import { Banner } from './Banner';
import helpCenterBanner from './resources/helpCenterBanner';

export const HelpCenterBanner = (): JSX.Element => {
   return <Banner testId={'dreryk-help-center-static-banner'} bannerUrl={helpCenterBanner} />;
};
